import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { checklistsApi } from 'src/Services/API';

const useFetchChecklist = (checklistId?: string) => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: ['fetch-checklist', assetId, checklistId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');
      if (!checklistId) throw new Error('No checklistId provided');

      return (await checklistsApi.checklistsControllerFindOne(checklistId, assetId)).data;
    },
    enabled: !!assetId && !!checklistId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export default useFetchChecklist;
